<template>
  <div class="myindex" id='id'>
    <van-nav-bar :border='false' :style="{'background-color':topcolor}">
      <img slot="title" class="navbartitle" :src="img.navmy_w" v-if="topheight>120">
      <img slot="title" class="navbartitle" :src="img.navmy" v-else>
    </van-nav-bar>
    <img class="hand-img" @click="changeBg" v-lazy="paramsinfo.bg?paramsinfo.member_bg:img.member_bg">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="message">
       <van-row type="flex" justify="space-between">
        <van-col span="18">
          <!-- <div hidden="true">{{user.city.name}} {{user.district.name}}</div> -->
          <!-- <div hidden="true">雷阵雨转多云 20~30 ℃ 不适宜洗车</div> -->
        </van-col>
        <van-col span="6">
          <div hidden="true">今日限号</div>
          <div hidden="true"><van-tag color="#605C6B">2 | 6</van-tag></div>
        </van-col>
      </van-row>
      <div class="info">
        <div class="head_box">
          <img class="head" :src="info.avatar&&info.avatar.substring(0,5)=='https' ? info.avatar : img.avatar">
          <img class="head_border" :src="img.border_pic" v-if="paramsinfo.auth.is_audit==1">
        </div>
        
        <div class="f-13 f-w c-black ml-20" v-if="paramsinfo.username">{{paramsinfo.username}}</div>
        <div class="f-16 f-w c-gray ml-20" v-else @click="myindexLogin()"> 点击登录</div>
        <div class="f-12 c-gray ml-20" style="display:flex" v-if="paramsinfo.auth.is_audit==1">
          <img class="member_car" style="padding-top: 5px;" :src="paramsinfo.auth.pic">
          <div style="flex: 1;">
            <div v-for="(item,index) in paramsinfo.auth.title" :key="'approve_'+index">
              {{item}}
            </div>
          </div>
        </div>
        <div class="f-12 c-gray ml-20" v-if="paramsinfo.cars"><img class="member_car" :src="img.member_car">{{paramsinfo.cars.title}} 车主</div>
        <div class="f-12 c-gray ml-20" v-if="info.intro">{{info.intro}}</div>
        <div class="f-12 c-gray ml-20" v-else>这个家伙很懒，什么都没有留下~</div>
        <van-row class="ml-20 mt-10">
          <van-col span="8" @click="myPraise">
            <span class="c-gray">获赞</span><span class="f-w c-black ml-10">{{info.praise_num}}</span>
          </van-col>
          <van-col span="8" @click="fans(0)">
            <span class="c-gray">关注</span><span class="f-w c-black ml-10">{{info.follow_num}}</span>
          </van-col>
          <van-col span="8" @click="fans(1)">
            <span class="c-gray">粉丝</span><span class="f-w c-black ml-10">{{info.fans_num}}</span>
          </van-col>
        </van-row>
      </div>
    </div>
    <div class="listleft">
      <div class="years">{{nowyear}}</div>
      <van-row>
        <van-col span="6">
          <div class="today">今天</div>
        </van-col>
        <van-col span="18">
          <div class="post" @click="post">
            <img :src="img.camera">
          </div>
        </van-col>
      </van-row>
      <van-list
      v-model="loading"
      :finished="finished"
      finished-text="已加载全部"
      :offset='580'
      @load="onLoad"
      :immediate-check="false"
      >
      <div slot="loading" class="list-loading">
        <img :src="img.loading" />
      </div>
      <div v-for="item in list" :key="'space_'+item.id">
        <div class="years" v-if="item.yearshow">{{item.year}}</div>
        <van-row v-if="item.cate.id==1">
          <van-col span="6">
            <div class="today" v-if="item.mon!=nowdata&&item.monshow">{{item.mon}}</div>
            <div class="location"></div>
          </van-col>
          <van-col span="18">
            <div class="content">
              <div class="typetime"><span>{{item.cate.type}}</span> - {{item.mon}}</div>
              <p class="title"  @click="goInfo(item.cate.id,item.id)">{{item.title}}</p>
              <span class="ellipsis-4 fonts"  @click="goInfo(item.cate.id,item.id)">{{item.content}}</span>
              <img @click="goInfo(item.cate.id,item.id)" class="listpic" v-if="item.cover||item.image.length>0" v-lazy="item.cover?item.cover:item.image[0]">
              <div @click="goInfo(item.cate.id,item.id)" v-if="item.video" class="videobox">
                <img class="listpic" v-lazy="img.default">
                <img class="videos" :src="img.plays">
              </div>
              <van-row type="flex" justify="space-between">
                <van-col span="20">
                  <span class="binbox">
                    <img class="binpic" :src="img.collect">
                    <span class="statenum" v-if="item.praise_num>0">{{item.praise_num}}</span>
                  </span>
                  <span class="binbox" @click="goInfo(item.cate.id,item.id)">
                    <img class="binpic" :src="img.comment">
                    <span class="statenum" v-if="item.comment_num>0">{{item.comment_num}}</span>
                  </span>
                  <span class="binbox" hidden="true">
                    <img class="binpic" :src="img.inrelay">
                    <span class="statenum"></span>
                  </span>
                </van-col>
                <van-col v-if="item.is_audit==1" class="bintright" span="4" @click="outrelay(item.title,item.content,item.id,item.post_id,item.share_image,item.cate.id)">
                  <img class="binpic" :src="img.outrelay">
                </van-col>
                <van-col v-else class="bintright" span="4">
                  <img class="binpic" :src="img.outrelay">
                </van-col>
              </van-row>
            </div>
          </van-col>
        </van-row>
        <van-row v-if="item.cate.id==2">
          <van-col span="6">
           <div class="today" v-if="item.mon!=nowdata&&item.monshow">{{item.mon}}</div>
           <div class="location"></div>
         </van-col>
         <van-col span="18">
          <div class="content">
            <div class="typetime"><span>{{item.cate.type}}</span> - {{item.mon}}</div>
            <p class="title" @click="goInfo(item.cate.id,item.id)"><img class="answtag" :src="img.questionicon">{{item.question}}</p>
            <span class="ellipsis-2 fonts" @click="goInfo(item.cate.id,item.id)" v-if="item.content">
              {{item.content}}
            </span>
            <img @click="goInfo(item.cate.id,item.id)" class="listpic" v-if="item.image[0]" v-lazy="item.image[0]">
            <!-- <van-row type="flex" justify="space-between">
              <van-col span="20">
                <span class="binbox">
                  <img class="binpic" :src="img.collect">
                  <span class="statenum" v-if="item.praise_num>0">{{item.praise_num}}</span>
                </span>
                <span class="binbox" @click="goInfo(item.cate.id,item.id)">
                  <img class="binpic" :src="img.comment">
                  <span class="statenum" v-if="item.comment_num>0">{{item.comment_num}}</span>
                </span>
                <span class="binbox" hidden="true">
                  <img class="binpic" :src="img.inrelay">
                  <span class="statenum"></span>
                </span>
              </van-col>
              <van-col class="bintright" span="4" @click="outrelay(item.question,item.content,item.id,item.post_id,item.image[0],item.cate.id)">
                <img class="binpic" :src="img.outrelay">
              </van-col>
            </van-row> -->
          </div>
        </van-col>
      </van-row>
      <van-row v-if="item.cate.id==3">
        <van-col span="6">
         <div class="today" v-if="item.mon!=nowdata&&item.monshow">{{item.mon}}</div>
         <div class="location"></div>
       </van-col>
       <van-col span="18">
        <div class="content">
          <div class="typetime"><span>{{item.cate.type}}</span> - {{item.mon}}</div>
          <p class="title" @click="goInfo(item.cate.id,item.id)">{{item.question.question}}</p>
          <span class="ellipsis-2 fonts" @click="goInfo(item.cate.id,item.id)" v-if="item.content&&item.content.text"><img class="answtag" :src="img.answericon">{{item.content.text}}</span>
          <img @click="goInfo(item.cate.id,item.id)" class="listpic" v-if="item.content&&item.content.img" v-lazy="item.content.img">
          <van-row type="flex" justify="space-between">
            <van-col span="20">
              <span class="binbox">
                <img class="binpic" :src="img.collect">
                <span class="statenum" v-if="item.praise_num>0">{{item.praise_num}}</span>
              </span>
              <span class="binbox" @click="goInfo(item.cate.id,item.id)">
                <img class="binpic" :src="img.comment">
                <span class="statenum" v-if="item.comment_num>0">{{item.comment_num}}</span>
              </span>
              <span class="binbox" hidden="true">
                <img class="binpic" :src="img.inrelay">
                <span class="statenum"></span>
              </span>
            </van-col>
            <van-col v-if="item.is_audit==1" class="bintright" span="4" @click="outrelay(item.question.question,item.content.text,item.id,item.post_id,item.content.img,item.cate.id)">
              <img class="binpic" :src="img.outrelay">
            </van-col>
            <van-col v-else class="bintright" span="4">
              <img class="binpic" :src="img.outrelay">
            </van-col>
          </van-row>
        </div>
      </van-col>
    </van-row>
    <van-row v-if="item.cate.id==4">
      <van-col span="6">
       <div class="today" v-if="item.mon!=nowdata&&item.monshow">{{item.mon}}</div>
       <div class="location"></div>
     </van-col>
     <van-col span="18">
      <div class="content">
        <div class="typetime">
          <span>{{item.cate.type}}</span>
        -{{item.date}}</div>
        <!-- <van-tag class="active" type="success">招募中</van-tag> -->
        <p class="title" @click="goInfo(item.cate.id,item.id)">{{item.title}}</p>
        <div class="sourtime mb-10">时间：{{item.start}}---{{item.end}}</div>
        <div class="sourtime mb-10" v-if="item.author">联系人：{{item.author}}</div>
        <!-- <img class="listpic" @click="pivewImg()" :src="img.member_bg"> -->
      </div>
    </van-col>
  </van-row>
</div>
</van-list>
</div>
</van-pull-refresh>
<van-action-sheet class="postsheet" v-model="show" title="发表" :round="false" @cancel="onpostCancel" @click-overlay="onpostCancel" close-icon='none' :duration="0" >
  <van-grid :border='false' :column-num="2">
    <van-grid-item class="postimg" :icon="img.post" @click="goPost(1)" text="写动态" />
    <!-- <van-grid-item class="postimg" :icon="img.images" @click="goPost(2)" text="图片" />
      <van-grid-item class="postimg" :icon="img.videos" @click="goPost(3)" text="视频" /> -->
      <van-grid-item class="postimg" :icon="img.question" @click="goPost(4)" text="提问" />
    </van-grid>
  </van-action-sheet>
  <van-action-sheet v-model="shareshow" :round="false" cancel-text="取消" @cancel="onCancel" @click-overlay="onCancel">
    <van-divider class="divider f-13">分享</van-divider>
    <van-grid :border='false' :column-num="2">
      <!-- <van-grid-item :icon="img.inrelay" /> -->
      <van-grid-item :icon="img.friends" @click="toShare(2)" />
      <van-grid-item :icon="img.wechat" @click="toShare(1)" />
    <!-- <van-grid-item :icon="img.link" />
      <van-grid-item :icon="img.poster" /> -->
    </van-grid>
  </van-action-sheet>
  <van-image-preview
  v-model="showState"
  :images="images"
  lazyLoad
  @close="close()"
  >
</van-image-preview>
</div>
</template>
<script>
  import active from '../../../api/lexus/active';
  import member from '../../../api/member/memberinfo';
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import { Tab, Tabs, List, Row, Col, Button, Tag, Grid, GridItem, Image, Icon,ActionSheet,Step, Steps,Divider,NavBar,PullRefresh,Dialog } from 'vant';
  export default {
    data () {
      return {
        active:0,
        steps:3,
        show:false,
        progress:"50%",
        params:{
          brand_id:1,
          page:1,
          size:4
        },
        param:{
          media_id:6,
          page:1,
          size:6
        },
        paramsh:{
          source:''
        },
        paramsinfo:'',
        list:[],
        lista:[],
        listh:[],
        oldlist:[],
        images:[],
        showState:false,
        info:'',
        shareshow:false,
        loading: false,
        finished: false,
        isLoading: false,
        topheight:0,
        topcolor:'transparent',
        img:{
          navmy: require('../../../assets/img/lexus/navmy.png'),
          navmy_w: require('../../../assets/img/lexus/navmy_w.png'),
          loading: require('../../../assets/img/loading_lexus.gif'),
          member_bg: require('../../../assets/img/lexus/my/member_bg.png'),
          avatar: require('../../../assets/img/lexus/default.png'),
          camera:require('../../../assets/img/lexus/my/camera.png'),
          collect: require('../../../assets/img/lexus/collect.png'),
          default: require('../../../assets/img/default_lexus.png'),
          collect_have: require('../../../assets/img/lexus/collect_have.png'),
          comment: require('../../../assets/img/lexus/comment.png'),
          inrelay: require('../../../assets/img/lexus/inrelay.png'),
          outrelay: require('../../../assets/img/lexus/outrelay.png'),
          post: require('../../../assets/img/lexus/my/post.png'),
          images: require('../../../assets/img/lexus/my/images.png'),
          videos: require('../../../assets/img/lexus/my/videos.png'),
          question: require('../../../assets/img/lexus/my/question.png'),
          mycircle: require('../../../assets/img/lexus/my/mycircle.png'),
          honour: require('../../../assets/img/lexus/my/honour.png'),
          honour_have: require('../../../assets/img/lexus/my/honour_have.png'),
          answericon: require('../../../assets/img/lexus/answericon.png'),
          questionicon: require('../../../assets/img/lexus/questionicon.png'),
          friends: require('../../../assets/img/lexus/friends.png'),
          wechat: require('../../../assets/img/lexus/wechat.png'),
          link: require('../../../assets/img/lexus/link.png'),
          poster: require('../../../assets/img/lexus/poster.png'),
          plays: require('../../../assets/img/lexus/plays.png'),
          member_car: require('../../../assets/img/member_car.png'),
          border_pic:require('../../../assets/img/lexus/border.gif'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: 9
      })
    },
    created () {
     this.$store.commit('param/show', false)
     this.$appService.isShowReturn({state: false})
     this.$appService.isTabbar({state: false})
     this.weburl=process.env.VUE_APP_URL
     this.$appService.getToken(v => {
      if(v.token) {
        this.getMyInfo()
        this.getMemberInfo()
        this.onRefresh()
        this.$store.dispatch('param/setToken', v.token)
      } else {
        // var params={
        //   url:'',
        //   pagetype:0
        // }
        // this.$appService.needLogin(params)
        var params={
          url:this.weburl+'/lexus/my/index',
          pagetype:2,
          isReturn: true 
        }
        this.$appService.needLogin(params)
      }
    })
     var date=new Date;
     this.nowyear = date.getFullYear()
     var month = date.getMonth() + 1;  
     var day = date.getDate(); 
     this.nowdata=month+'.'+day
     var params={
      event_code: '我',
      event_id: '',
      title: '',
      value: '',
      path: '/Lexus/My/Index.vue',
      user_id: this.user ? this.user.id : 0,
      source: this.source
    }
    common.BurialPoint(params).then(res => {
      if(res.data.state==1){
      }
    })
  },
  watch: {
    '$route'() {
      if(this.$route.query.refresh ==1) {
        that.getMyInfo()
        that.getMemberInfo()
        that.onRefresh()
      }

    }
  },
  mounted(){
    // window.addEventListener('scroll',this.scrollHandle);
  },
  methods: {
    scrollHandle(e){
      let top = e.srcElement.scrollingElement.scrollTop;    // 获取页面滚动高度
      console.log(top);
      if (top > 120) {
        this.topheight=top
        this.topcolor= '#fff'
      } else {
        this.topheight= top
        this.topcolor= 'transparent'
      }
    },
    getMyInfo(){
     console.log('---getMyInfo')
     setTimeout(() => {
       var luser=JSON.parse(localStorage.getItem("user"))
       var id=luser.data.id
       var params={
        media_id: 6
      }
      member.getMyInfo(id,params).then(res => {
        if(res.data.state==1){
          this.info=res.data.data
          this.user.id=res.data.data.id
          this.user.avatar=res.data.data.avatar
        }
      })
    }, 500);
   },
   getMemberInfo(){
    var params={
      source: this.source
    }
    member.getMemberInfo(params).then(res => {
      if(res.data.state == 1) {
        this.paramsinfo=res.data.data
        this.paramsinfo.member_bg=res.data.data.bg
      }
    })
  },
  pivewImg(image){
    this.$appService.isTabbar({state: true})
    var images=[]
    images.push(image)
    this.images=images
    this.showState=true
  },
  close(){
    this.$appService.isTabbar({state: false})
  },
  post(){
    this.$appService.isTabbar({state: true})
    this.show=true
    
  },
  goPost(type){
    this.$appService.getToken(v => {
      if(v.token) {
        this.$store.dispatch('param/setToken', v.token)
        var params={
          type:type
        }
        this.show=false
        this.$appService.isTabbar({state: false})
        this.$appService.goPost(params)
      } else {
        var params={
          pagetype:1,
          type:type
        }
        this.$appService.needLogin(params)
      }
    })
  },
  myindexLogin(){
    var params={
      url:this.weburl+'/lexus/my/index',
      pagetype:2,
      isReturn: true 
    }
    this.$appService.needLogin(params)
  },
  ActiveInfo(type,id){
    var params={
      url:'' ,
      isReturn: true 
    }
    if(type==1){
      params.url=this.weburl+'/lexus/activeapply/'+id+'?source='+this.source
    }else{
      params.url=this.weburl+'/lexus/activeinfo/'+id+'?source='+this.source
    }
    this.$appService.openWebView(params)
  },
  goInfo(type,id){
    var params={
      url:'' ,
      isReturn: true 
    }
    if(type==1){
      params.url=this.weburl+'/lexus/bbs/'+id+'?source='+this.source
    }else if(type==2){
      params.url=this.weburl+'/lexus/ask/'+id+'?source='+this.source
    }else if(type==3){

      params.url=this.weburl+'/lexus/ask/'+id+'/answer'+'?source='+this.source
    }else if(type==4){
      params.url=this.weburl+'/lexus/activeinfo/'+id+'?source='+this.source
    } 
    this.$appService.openWebView(params)
  },
  fans(type){
    var params={
      url:this.weburl+'/lexus/my/fanslist/'+type+'?source='+this.source,
      isReturn: true 
    }
    this.$appService.openWebView(params)
  },
  outrelay(title,content,id,post_id,imageUrl,cate){
    var user_id=this.user?this.user.id:0
    this.$appService.isTabbar({state: true})
    this.shareshow=true
    this.sharetitle=title
    this.sharecontent=content
    if(cate==1){
      if(post_id>0){
        this.shareurl='/pages/article/article?scene='+post_id+'-'+user_id
        var url='/lexus/article/'+post_id+'/post'
        this.sharetype=1
        this.shareid=post_id
      }else{
        this.shareurl='/pages/articleinfo/articleinfo?scene='+id+'-'+user_id
        var url='/lexus/bbs/'+id
        this.sharetype=2
        this.shareid=id
      }
    }else if(cate==2){

    }
    this.shareweburl=this.weburl+url+'?source='+this.source
    
    if(imageUrl){
      this.shareimageUrl=imageUrl
    }else{
      this.shareimageUrl='https://pic.motortime.com/logo/lexus_logo.png'
    }
  },
  toShare(type){

    if(type==1){
      var params={
        type:type,
        title:this.sharetitle,
        content:this.sharecontent,
        url:this.shareurl,
        imageUrl:this.shareimageUrl,
        weburl:this.shareweburl,
        wechatid:'gh_d2c493f1bc41'
      }
      this.shareshow=false
      this.$appService.shareContent(params)
      this.$appService.isTabbar({state: false})
    }else{
      this.$appService.getToken(v => {
        if(v.token) {
          if(this.sharetype==2){
            var para={
              source:9,
              cid:this.shareid,
              user_id:this.user.id
            }
            bbs.getPoster(para).then(res => {
              if(res.data.state == 1) {
                var params={
                  type:type,
                  title:this.sharetitle,
                  content:this.sharecontent,
                  url:this.shareurl,
                  imageUrl:res.data.data.share_url,
                  weburl:this.shareweburl,
                  wechatid:'gh_d2c493f1bc41'
                }
                this.shareshow=false
                this.$appService.isTabbar({state: false})
                this.$appService.shareContent(params)
              }
            })
          }else{
            var para={
              source:9,
              id:this.shareid,
              user_id:this.user.id
            }
            content.getPoster(para).then(res => {
              if(res.data.state == 1) {
                var params={
                  type:type,
                  title:this.sharetitle,
                  content:this.sharecontent,
                  url:this.shareurl,
                  imageUrl:res.data.data.share_url,
                  weburl:this.shareweburl,
                  wechatid:'gh_d2c493f1bc41'
                }
                this.shareshow=false
                this.$appService.isTabbar({state: false})
                this.$appService.shareContent(params)
              }
            })
          }
        }else{
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
    }
  },
  onCancel(){
    this.shareshow=false
    this.$appService.isTabbar({state: false})
  },
  onpostCancel(){
    this.show=false
    this.$appService.isTabbar({state: false})
  },
  onRefresh() {
    this.$appService.getToken(v => {
      if(v.token) {
        this.$store.dispatch('param/setToken', v.token)
        setTimeout(() => {
          this.isLoading = false;
          this.list=[]
          this.oldlist=[]
          this.lista=[]
          this.listh=[]
          this.params.page=1
          this.param.page=1
          this.loading = false
          this.finished=false
          this.onLoad()
          this.getMyInfo()
          this.getMemberInfo()
        }, 500);
      }
    })
  },
  onClick(name){
    this.list=[]
    this.oldlist=[]
    this.lista=[]
    this.listh=[]
    this.active=name
    this.params.page=1
    this.param.page=1
    this.loading = false
    this.finished=false
    var cc=document.getElementById('id');
    cc.scrollIntoView(false);
  },
  changeBg(){
    var params={
      type:1
    }
    this.$appService.openPhotoAlbum(params,v => {
      console.log('openPhotoAlbum=='+v.pic_url)
      this.paramsinfo.member_bg=v.pic_url
      this.paramsinfo.bg=v.pic
      this.paramsinfo.avatar=''
      this.paramsinfo.source=this.source
      member.updateInfo(this.paramsinfo).then(res => {
        if(res.data.state == 1) {
         this.$toast.success('修改成功');
       }
     })
    })
  },
  myPraise(){
    this.$appService.getToken(v => {
      if(v.token) {
        Dialog.alert({
          title: this.info.username,
          message: '共获得'+this.info.praise_num+'个赞',
          closeOnClickOverlay:true,
          confirmButtonColor:'#ffffff',
          className:'mydialog'
        }).then(() => {

        });
      } else {
        var params={
          pagetype:1,
          type:type
        }
        this.$appService.needLogin(params)
      }
    })

  },
  onLoad(){
    if(this.active==0){
      var user_id = this.user ? this.user.id : 0
      setTimeout(() => {
        member.getSpaceList(this.param,user_id).then(res => {
          if(res.data.state==1){
            this.param.page += 1
            this.total = res.data.data.total
            this.loading = false
            if(res.data.data.data.length == 0) {
              this.finished = true
            }
            this.oldlist.push.apply(this.oldlist, res.data.data.data)
            let list=this.oldlist;
            let topiclist=[];
            let arr=[]
            for(var i=0;i<list.length;i++){
             let year= list[i].year
             let mon= list[i].date

             list[i].year=year
             list[i].mon=mon
           }
           for(var i=0;i<list.length;i++){
            if(i>0){
              if(list[i].year==list[i-1].year){
                list[i].yearshow=false
              }else{
                list[i].yearshow=true
              }
              if(list[i].mon==list[i-1].mon){
                list[i].monshow=false
              }else{
                list[i].monshow=true
              }
            }else{
              list[i].yearshow=true
              list[i].monshow=true
            }
          }
          this.list= list
        }
      })
      }, 500);
    }else if(this.active==1){
      setTimeout(() => {
        active.getMyActive(this.params).then(res => {
          this.lista.push.apply(this.lista, res.data.data.data)
          this.params.page += 1
          this.loading = false
          if(res.data.data.data.length == 0) {
            this.finished = true
          }
        })
      }, 500);
    }else{
      setTimeout(() => {
        this.listh=[]
        this.loading = false
        this.finished = true
            // member.getHonor(this.paramsh).then(res => {
            //   this.listh.push.apply(this.listh, res.data.data.data)
            //   this.paramsh.page += 1
            //   this.loading = false
            //   if(res.data.data.data.length == 0) {
            //     this.finished = true
            //   }
            // })
          }, 500);
    }
  },
},
components: {
  [Row.name]: Row,
  [Col.name]: Col,
  [Grid.name]: Grid,
  [GridItem.name]: GridItem,
  [List.name]: List,
  [Button.name]: Button,
  [Tabs.name]: Tabs,
  [Tab.name]: Tab,
  [Tag.name]: Tag,
  [Image.name]:Image,
  [Icon.name]:Icon,
  [ActionSheet.name]:ActionSheet,
  [Step.name]:Step,
  [Steps.name]:Steps,
  [Divider.name]:Divider,
  [NavBar.name]:NavBar,
  [PullRefresh.name]:PullRefresh,
  [Dialog.name]:Dialog 
}
}
</script>

<style lang="scss">
  .myindex{
    padding-bottom: 60px;
    .van-nav-bar{
      z-index: 999;
      position: fixed;
      top: 0;
      width: 100%;
      .van-nav-bar__left{
        top: 10px;
        .homemem{
          width:30px;
          height:30px;
          object-fit: cover;
        }
      }
      .van-nav-bar__title{
        .navbartitle{
          margin-top: 10px;
          width: 30px;
          height: 27px;
        }
      }
      .van-nav-bar__right{
        top: 5px;
        .homewrite{
          width: 20px;
        }
      }
    }
    a{
      color: #3a3a3a;
    }
    .hand-img{
      width: 100%;
      height: 260px;
      position: fixed;
      top: 0;
      object-fit: cover;
    }
    .message{
      position: relative;
      color: #fff;
      font-size: 12px;
      margin-top: 40%;
      padding: 0 15px;
      line-height: 2;
      .van-col--6{
        text-align: center;
      }
      .van-tag {
        padding: 5px 10px;
        letter-spacing: 3px;
        border-radius: 1.5px;
      }
      .info{
        width: 100%;
        height: 210px;
        z-index: 99;
        position: relative;
        margin-top: 20px;
        background-color: #fff;
        border-radius: 1.5px;
        box-shadow: 0.053333rem 0.053333rem 0.133333rem rgba(0, 0, 0, 0.05);
        .head{
          width: 60px;
          height: 60px;
          border-radius: 1.5px;
        }
        .head_box{
         width: 60px;
         height: 60px;
         position:relative;
         padding: 15px 20px 0 20px;
       }
       .head_border{
         width: 60px;
         height: 60px;
         position:absolute;
         left: 20px;
       }
     }
   }
   .van-tabs{
    background-color: #fff;
  }
  .van-ellipsis{
    font-weight: bold;
  }
  .ml-20{
    margin-left: 20px;
  }
  .ml-10{
    margin-left: 10px;
  }
  .mt-10{
    margin-top: 10px;
  }
  .mb-10{
    margin-bottom: 10px;
  }
  .listleft{
    padding: 15px;
    background: #fff;
    .years{
      font-size: 18px;
      color: #9a9a9a;
      font-weight: bold;
    }
    .today{
      font-size: 20px;
      font-weight: bold;
      margin-top: 18px;
      color: #3A3A3A;
    }
    .van-col--18{
      border-bottom: 1px solid #f8f8f8;
    }
    .location{
      font-size: 12px;
      color: #9A9A9A;
      margin-top: 10px;
    }

    .relay{
      height: 100px;
      padding: 10px;
      background-color: #F2F6FA;
      .relaytitle{
        font-size: 15px;
        font-weight: bold;
      }
      .relaypic{
        width: 100%;
        height: 100px;
        border-radius: 1.5px;
      }
    }
  }
  .content{
    background: #fff;
    .pd-20{
      padding: 0 20px;
    }
    padding: 20px 0;
    .typetime{
      font-size: 12px;
      color: #9A9A9A;
    }
    .title{
      font-size: 14px;
      font-weight: bold;
      letter-spacing: 2px;
    }
    .listpic{
      width: 100%;
      height: 190px;
      border-radius: 1.5px;
      object-fit: cover;
    }
    .videobox{
      position: relative;
    }
    .videos{
      width: 26px;
      height: 26px;
      position: absolute;
      left: 45%;
      top: 40%;
    }
    .activepic{
      width: 100%;
      height: 230px;
    }
    .binbox{
      margin-right:20px;
      .binpic{
        width:15px;
        height:15px;
        margin-right:8px;
        vertical-align: middle;
      }
    }
    .bintright{
      text-align:right;
      .binpic{
        width:15px;
        height:15px;
        margin-right:8px;
        vertical-align: middle;
      }
    }
    .statenum{
      font-size: 13px;
      color: #605C6B;
        // font-weight: bold;
        vertical-align: middle;
      }
      .sourtime{
        font-size: 12px;
        color: #9A9A9A;
      }
      .fonts{
        font-size: 13px;
        margin-bottom: 10px;
      }
      .questag{
        padding: 2px 3px;
        margin-right: 5px;
      }
      .answtag{
        width: 15px;
        height: 15px;
        margin-right: 10px;
      }
      .active{
        padding: 0;
        margin-right: 5px;
      }
    }
    .post{
      width: 90px;
      height: 90px;
      border-radius: 1.5px;
      background-color: #F8F8F8;
      margin-bottom: 20px;
      margin-top: 20px;
      img{
        width: 30px;
        height: 26px;
        padding: 30px;
      }
    }
    .postsheet{
      height: 150px;
      .van-action-sheet__header{

        font-size: 13px;
      }
      .postimg{
       .van-icon__image{
        width: 15px;
        height: 15px;
      }
    }
  }
  .van-step__title{
    margin-top: 50px;
  }
  .van-step--horizontal:first-child .van-step__title{
    margin-left: -8px;
  }
  .van-step--horizontal:last-child .van-step__title{
    margin-right: -8px;
  }
  .van-step--finish .van-step__circle, .van-step--finish .van-step__line{
    background-color: #9a9a9a;
  }
  .honour{
    background: #fff;
    .honourpic{
      width: 56px;
      height: 65px;
    }
    .progressbox{
      width: 100%;
      height: 7px;
      background-color: #F8F8F8;
      border:1px solid #F8F8F8;
      .myprogress{
        height: 7px;
        background-color: #605C6B;
      }
    }
  }
  .van-pull-refresh__head{
    top: 0;
  }
  .van-button--default{
    background-color:#3a3a3a !important;
  }

}
.mydialog{
  border-radius: 3px !important;
  .van-dialog__header{
    margin-top: 10px;
  }
  .van-dialog__content{
    height: 80px;
  }
}

</style>
